import {
  addDays,
  addHours,
  addMinutes,
  addMonths,
  addWeeks,
  format,
  startOfDay,
  startOfHour,
  startOfMinute,
  startOfMonth,
  startOfWeek,
} from "date-fns";

function alignToStep(date, unit, step) {
  const safeStep = Math.max(1, step);

  if (unit === "minute") {
    const aligned = startOfMinute(date);
    const minute = aligned.getMinutes();
    aligned.setMinutes(minute - (minute % safeStep), 0, 0);
    return aligned;
  }

  if (unit === "hour") {
    const aligned = startOfHour(date);
    const hour = aligned.getHours();
    aligned.setHours(hour - (hour % safeStep), 0, 0, 0);
    return aligned;
  }

  if (unit === "day") {
    const aligned = startOfDay(date);
    const dayOfMonth = aligned.getDate();
    aligned.setDate(dayOfMonth - ((dayOfMonth - 1) % safeStep));
    return aligned;
  }

  if (unit === "week") {
    const aligned = startOfWeek(date);
    if (safeStep === 1) return aligned;
    const anchor = startOfWeek(new Date(0));
    const weekMs = 7 * 24 * 60 * 60 * 1000;
    const diffWeeks = Math.floor((aligned.getTime() - anchor.getTime()) / weekMs);
    const remainder = ((diffWeeks % safeStep) + safeStep) % safeStep;
    return addWeeks(aligned, -remainder);
  }

  const aligned = startOfMonth(date);
  if (safeStep === 1) return aligned;
  const absoluteMonth = aligned.getFullYear() * 12 + aligned.getMonth();
  const remainder = ((absoluteMonth % safeStep) + safeStep) % safeStep;
  return addMonths(aligned, -remainder);
}

function addStep(date, unit, step) {
  if (unit === "minute") return addMinutes(date, step);
  if (unit === "hour") return addHours(date, step);
  if (unit === "day") return addDays(date, step);
  if (unit === "week") return addWeeks(date, step);
  return addMonths(date, step);
}

function iterateMarks(range, unit, step, fmt) {
  const marks = [];
  const safeStep = Math.max(1, step);
  const end = addStep(range.end, unit, safeStep).getTime();
  let cursor = alignToStep(range.start, unit, safeStep);

  while (cursor.getTime() > range.start.getTime()) {
    cursor = addStep(cursor, unit, -safeStep);
  }
  cursor = addStep(cursor, unit, -safeStep);

  while (cursor.getTime() <= end) {
    marks.push({
      ts: cursor.getTime(),
      label: fmt ? format(cursor, fmt) : "",
    });
    cursor = addStep(cursor, unit, safeStep);
  }

  return marks;
}

export function generateTimelineTicks(range, preset) {
  const major = iterateMarks(range, preset.majorUnit, preset.majorStep, preset.majorFormat);
  const minor = iterateMarks(range, preset.minorUnit, preset.minorStep, null);

  const majorTs = new Set(major.map((tick) => tick.ts));
  const minorFiltered = minor.filter((tick) => !majorTs.has(tick.ts));

  return { major, minor: minorFiltered };
}

export function hideCollidingMajorLabels(majorTicks, getPositionPx, minGapPx = 56) {
  let lastShown = Number.NEGATIVE_INFINITY;
  return majorTicks.map((tick) => {
    const pos = getPositionPx(tick);
    const showLabel = pos - lastShown >= minGapPx;
    if (showLabel) lastShown = pos;
    return { ...tick, showLabel };
  });
}
